import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/Button';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const navLinks = [{
    name: 'Despre',
    href: '#despre'
  }, {
    name: 'Metoda 3S',
    href: '#metoda'
  }, {
    name: 'Servicii',
    href: '#servicii'
  }, {
    name: 'Testimoniale',
    href: '#testimoniale'
  }, {
    name: 'FAQ',
    href: '#faq'
  }];
  return <nav className="sticky top-0 z-50 w-full bg-brand-bg/90 backdrop-blur-md border-b border-brand-primary/10" data-id="element-148">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-149">
        <div className="flex justify-between items-center h-20" data-id="element-150">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-151">
            <a href="#" className="font-serif text-2xl font-bold text-brand-primary" data-id="element-152">
              Daniela Sămărtinean
            </a>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-153">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-brand-text hover:text-brand-primary transition-colors font-medium text-sm" data-id="element-154">
                {link.name}
              </a>)}
            <Button variant="accent" size="sm" onClick={() => window.location.href = '#contact'} data-id="element-155">
              Rezervă Sesiunea
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center" data-id="element-156">
            <button onClick={() => setIsOpen(!isOpen)} className="text-brand-text hover:text-brand-primary p-2" aria-label="Toggle menu" data-id="element-157">
              {isOpen ? <X size={24} data-id="element-158" /> : <Menu size={24} data-id="element-159" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && <div className="md:hidden bg-brand-bg border-b border-brand-primary/10" data-id="element-160">
          <div className="px-4 pt-2 pb-6 space-y-2" data-id="element-161">
            {navLinks.map(link => <a key={link.name} href={link.href} className="block px-3 py-2 text-base font-medium text-brand-text hover:text-brand-primary hover:bg-brand-secondary/10 rounded-md" onClick={() => setIsOpen(false)} data-id="element-162">
                {link.name}
              </a>)}
            <div className="pt-4" data-id="element-163">
              <Button variant="accent" fullWidth onClick={() => {
            window.location.href = '#contact';
            setIsOpen(false);
          }} data-id="element-164">
                Rezervă Sesiunea
              </Button>
            </div>
          </div>
        </div>}
    </nav>;
}